// src/contexts/AnalyticsFilterContext.tsx
import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

// 1. Define the shape of your context
type AnalyticsFilterContextType = {
  durationList: { name: string; value: string }[];
  duration: string;
  setDuration: Dispatch<SetStateAction<string>>;
};

// 2. Create the context with an initial “undefined” to force provider usage
const AnalyticsFilterContext = createContext<
  AnalyticsFilterContextType | undefined
>(undefined);

// 3. Create a Provider component
type AnalyticsFilterProviderProps = {
  children: ReactNode;
};

const durationList = [
  { name: "12 months", value: "12month" },
  { name: "30 days", value: "30days" },
  { name: "7 days", value: "7days" },
  { name: "Yesterday", value: "24hours" },
  { name: "Today", value: "12hours" },
];

export const AnalyticsFilterProvider: React.FC<
  AnalyticsFilterProviderProps
> = ({ children }) => {
  const [duration, setDuration] = useState<string>(durationList?.[0]?.value);

  return (
    <AnalyticsFilterContext.Provider
      value={{ durationList, duration, setDuration }}
    >
      {children}
    </AnalyticsFilterContext.Provider>
  );
};

// 4. Create a custom hook for easy consumption
export const useAnalyticsFilter = (): AnalyticsFilterContextType => {
  const context = useContext(AnalyticsFilterContext);
  if (!context) {
    throw new Error(
      "useAnalyticsFilter must be used within a AnalyticsProvider"
    );
  }
  return context;
};
